import { currencyFormat } from 'helpers/utils';
import React from 'react';

interface OrderSummaryDetailsProps {
  totalAmount: number;
  discountAmount: number;
  taxAmount: number;
  shippingCost: number;
}

const OrderSummaryDetails = ({
  totalAmount,
  discountAmount,
  taxAmount,
  shippingCost
}: OrderSummaryDetailsProps) => {
  return (
    <div>
      <div className="d-flex justify-content-between">
        <p className="text-body fw-semibold">Items subtotal :</p>
        <p className="text-body-emphasis fw-semibold">
          {currencyFormat(totalAmount, { currency: 'SAR' })}
        </p>
      </div>
      <div className="d-flex justify-content-between">
        <p className="text-body fw-semibold">Discount :</p>
        <p className="text-danger fw-semibold">
          -{currencyFormat(discountAmount, { currency: 'SAR' })}
        </p>
      </div>
      <div className="d-flex justify-content-between">
        <p className="text-body fw-semibold">Tax :</p>
        <p className="text-body-emphasis fw-semibold">
          {currencyFormat(taxAmount, { currency: 'SAR' })}
        </p>
      </div>
      <div className="d-flex justify-content-between">
        <p className="text-body fw-semibold">Subtotal :</p>
        <p className="text-body-emphasis fw-semibold">
          {currencyFormat(totalAmount - discountAmount + taxAmount, {
            currency: 'SAR'
          })}
        </p>
      </div>
      <div className="d-flex justify-content-between">
        <p className="text-body fw-semibold">Shipping Cost :</p>
        <p className="text-body-emphasis fw-semibold">
          {currencyFormat(shippingCost, { currency: 'SAR' })}
        </p>
      </div>
    </div>
  );
};

export default OrderSummaryDetails;
